import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "48px 16px 72px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "720px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "24px 20px",
  },
  title: {
    margin: "0 0 6px",
    fontSize: "26px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    color: "#cbd5e1",
    fontSize: "13px",
    marginBottom: "12px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  labelRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  label: {
    fontWeight: 700,
    color: "#f8fafc",
    fontSize: "14px",
  },
  inputWrap: {
    position: "relative",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.05)",
    color: "#f8fafc",
    fontSize: "15px",
    boxSizing: "border-box",
  },
  toggleBtn: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.12)",
    color: "#f8fafc",
    borderRadius: "10px",
    padding: "4px 10px",
    cursor: "pointer",
    fontSize: "14px",
  },
  error: {
    color: "#fca5a5",
    fontSize: "12px",
  },
  checkboxRow: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginTop: "6px",
  },
  checkboxLabel: {
    fontSize: "12px",
    color: "#e7e7e9",
  },
  linksRow: {
    display: "flex",
    gap: "14px",
    marginTop: "10px",
  },
  link: {
    color: "#fb923c",
    fontWeight: 700,
    textDecoration: "none",
    fontSize: "14px",
  },
  submitRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "4px",
  },
  submitBtn: {
    padding: "14px 16px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    fontWeight: 800,
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(249,115,22,0.26)",
    minWidth: "120px",
  },
  submitBtnDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  popup: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "rgba(15,10,8,0.9)",
    color: "#f8fafc",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 16px 32px rgba(0,0,0,0.35)",
    maxWidth: "280px",
    zIndex: 1000,
    fontSize: "14px",
  },
};

const autofillStyles = `
.signup-input {
  background: rgba(15,15,20,0.9) !important;
  color: #f8fafc !important;
  border: 1px solid rgba(255,255,255,0.14) !important;
  border-radius: 12px;
  padding: 12px 14px;
  box-sizing: border-box;
  transition: outline-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}
.signup-input::placeholder {
  color: #94a3b8;
}
.signup-input:focus {
  outline: 2px solid rgba(249,115,22,0.45) !important;
  border-color: rgba(249,115,22,0.45) !important;
  box-shadow: 0 0 0 1000px rgba(15,15,20,0.95) inset !important;
}
.signup-input:-webkit-autofill,
.signup-input:-webkit-autofill:hover,
.signup-input:-webkit-autofill:focus,
.signup-input:-webkit-autofill:active {
  background: rgba(15,15,20,0.95) !important;
  -webkit-text-fill-color: #f8fafc !important;
  box-shadow: 0 0 0 1000px rgba(15,15,20,0.95) inset !important;
  caret-color: #f8fafc;
  border: 1px solid rgba(255,255,255,0.14) !important;
}
`;

export default function Signup(){

    const[email,setEmail] = useState('');
    const[pw,setPw] = useState('');
    const[confirmPw, setConfirmPw] = useState('');
    const[mobile, setMobile] = useState('');
    const[uid, setUid] = useState('');
    const[publickey, setPublickey] = useState('');
    const[secretkey, setSecretkey] = useState('');
    const[nickname, setNickname] = useState('');
    const[homeconsent, setHomeconsent] = useState(false);
    const[consent, setConsent] = useState(false);

    const[showMessage, setShowMessage] = useState(false);
    const[confirmMessage, setConfirmMessage] = useState('');

    const[emailValid, setEmailValid] = useState(false);
    const[pwValid, setPwValid] = useState(false);
    const[confirmPwValid, setConfirmPwValid] = useState('');
    const[mobileValid, setMobileValid] = useState('');
    const[uidValid, setUidValid] = useState('');
    const[publickeyValid, setPublickeyValid] = useState('');
    const[secretkeyValid, setSecretkeyValid] = useState('');
    const[nicknameValid, setNicknameValid] = useState('');

    const[notAllow, setNotAllow] = useState(true);

    const[showPassword, setShowPassword] = useState(false); // 비밀번호 보이기 토글 상태
    const[showConfirmPassword, setShowConfirmPassword] = useState(false); // 비밀번호 보이기 토글 상태

    useEffect(() => {
      // 여기에 통신 요청이 완료되면 알림 메시지를 자동으로 사라지게 하는 로직을 추가하세요.
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 3000); // 5초 후에 알림 메시지를 숨김
      return () => clearTimeout(timer); // 컴포넌트가 언마운트되면 타이머 해제
    }, [showMessage]); 

    
    const handleEmail = (e) => {
      const newEmail = e.target.value.trim();
      setEmail(newEmail);
      const regex = 
      /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (regex.test(newEmail)) {
          setEmailValid(true);
        } 
      else {
          setEmailValid(false);
        }
      };
    const handlePw = (e) => {
      const newPw = e.target.value.trim();
      setPw(newPw);
        const regex =
          /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
        if (regex.test(newPw)) {
          setPwValid(true);
        } 
      else {
          setPwValid(false);
        }
      };

    const handleConfirmPw = (e) => {
      const newConfirmPw = e.target.value.trim();
      setConfirmPw(newConfirmPw);
      const regex =
        /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
      if (regex.test(newConfirmPw) && newConfirmPw === pw) {
        setConfirmPwValid(true);
        } 
      else {
          setConfirmPwValid(false);
          }
      };
      
    const handleMobile = (e) => {
      const mobileValue = e.target.value.trim();
      setMobile(mobileValue);
      const regex = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
      if (regex.test(mobileValue)) {
        setMobileValid(true);
      } else {
        setMobileValid(false);
      }
    };
        

    const handleUid = (e) => {
          const newUid = e.target.value.trim();
          setUid(newUid);
          const regex = /^[0-9]{13}$/;
          if (regex.test(newUid)) {
            setUidValid(true);
          } else {
            setUidValid(false);
          }
        };

    
    const handlePublickey = (e) => {
      const newpublickey = e.target.value.trim();
      setPublickey(newpublickey);
      const regex = /^[a-zA-Z0-9_-]{10,70}$/;
      if (regex.test(newpublickey)) {
        setPublickeyValid(true);
      } else {
        setPublickeyValid(false);
      }
    };

    const handleSecretkey = (e) => {
      const newSecretkey = e.target.value.trim();
      setSecretkey(newSecretkey);
      const regex = /^[a-zA-Z0-9]{10,100}$/;
      if (regex.test(newSecretkey)) {
        setSecretkeyValid(true);
      } else {
        setSecretkeyValid(false);
      }
    };

    const handleNickname = (e) => {
      const newNickname = e.target.value.trim();
      setNickname(newNickname);
      const regex =
      /^[ㄱ-ㅎ가-힣a-zA-Z0-9]{2,16}$/;
      if (regex.test(newNickname)) {
        setNicknameValid(true);
      } else {
        setNicknameValid(false);
      }
    };

    const handleHomeconsent = () => setHomeconsent(!homeconsent);
    const handleConsent = () => setConsent(!consent);
    
    useEffect(() => {
        if(emailValid && pwValid && confirmPwValid && mobileValid && uidValid && publickeyValid && secretkeyValid && nicknameValid && homeconsent && consent) {
          setNotAllow(false);
          return;
        }
        setNotAllow(true);
      }, [emailValid, pwValid, confirmPwValid, mobileValid, uidValid, publickeyValid, secretkeyValid, nicknameValid, homeconsent, consent]);
    
    
    const onClickSaveFile = () => {

      setShowMessage(true);
      setConfirmMessage(`거래소와 통신중입니다. 잠시만 기다리세요!`);

      fetch('/signup/members', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email,
                pw,
                mobile,
                uid,
                publickey,
                secretkey,
                nickname,
            }),
        })
        .then(async response => {
          const text = await response.text();
          if (!text || text.trim().length === 0) {
            throw new Error('서버 응답이 비어 있습니다.');
          }
          let data;
          try {
            data = JSON.parse(text);
          } catch (parseErr) {
            throw new Error(`응답 파싱 실패: ${text}`);
          }
          if (!response.ok) {
            throw new Error(data.message || '요청 실패');
          }
          return data;
        })
        .then(result => {
            setConfirmMessage(result.message || '요청이 처리되었습니다.');
            setShowMessage(true);
            if (result.ok === true){
              const redirectUrl = `/LoginAts`;
              window.location.href = redirectUrl;
            }
        })
        .catch(error => {
            console.log('오류 발생:', error);
            setConfirmMessage(error.message || '요청 처리 중 오류가 발생했습니다.');
            setShowMessage(true);
        });
      
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSaveFile();
    }
  };

    return(
      <>
        <style dangerouslySetInnerHTML={{ __html: autofillStyles }} />
        <div style={styles.page}>
          <div style={styles.container}>
            <div style={styles.card}>
              <h2 style={styles.title}>회원가입</h2>
              <p style={styles.helper}>계정 정보를 입력하고 약관 동의 후 가입을 완료하세요.</p>

            <div style={styles.form}>
              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>E-mail address</span>
                </div>
                <div style={styles.inputWrap}>
                  <input 
                    type='text'
                    placeholder="test@gmail.com"
                    value={email}
                    onChange={handleEmail}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                </div>
                {!emailValid && email.length > 0 && (
                  <div style={styles.error}>Please enter a valid email format.</div>
                )}
              </div>

              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>Password</span>
                </div>
                <div style={styles.inputWrap}>
                  <input
                    type={showPassword ? "text" : "password"} // 비밀번호 표시 여부 토글
                    placeholder="At least 8 characters including English letters, numbers, and special characters"
                    value={pw}
                    onChange={handlePw}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={styles.toggleBtn}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
                {!pwValid && pw.length > 0 && (
                  <div style={styles.error}>
                    Please enter at least 8 characters including English letters, numbers, special characters, and uppercase letters.
                  </div>
                )}
              </div>

              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>Confirm password</span>
                </div>
                <div style={styles.inputWrap}>
                  <input
                    type={showConfirmPassword ? "text" : "password"} // 비밀번호 표시 여부 토글
                    placeholder="Please enter the same password"
                    value={confirmPw}
                    onChange={handleConfirmPw}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={styles.toggleBtn}
                  >
                    {showConfirmPassword ? "Hide" : "Show"}
                  </button>
                </div>
                {!confirmPwValid && confirmPw.length > 0 && (
                  <div style={styles.error}>Please enter the same password</div>
                )}
              </div>

              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>Mobile Number</span>
                </div>
                <div style={styles.inputWrap}>
                  <input 
                    type='text'
                    placeholder="Please enter only numbers without '-'"
                    value={mobile}
                    onChange={handleMobile}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                </div>
                {!mobileValid && mobile.length > 0 && (
                  <div style={styles.error}>Please enter only numbers without '-'</div>
                )}
              </div>

              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>UID</span>
                </div>
                <div style={styles.inputWrap}>
                  <input 
                    type='text'
                    placeholder="Enter only 13 digits."
                    value={uid}
                    onChange={handleUid}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                </div>
                {!uidValid && uid.length > 0 && (
                  <div style={styles.error}>Please enter only 13 digits.</div>
                )}
              </div>

              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>publickey</span>
                </div>
                <div style={styles.inputWrap}>
                  <input 
                    type='text'
                    placeholder="Please enter the publickey value exactly(copy and paste)"
                    value={publickey}
                    onChange={handlePublickey}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                </div>
                {!publickeyValid && publickey.length > 0 && (
                  <div style={styles.error}>Please enter correct publickey inputs.</div>
                )}
              </div>

              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>SecretKey</span>
                </div>
                <div style={styles.inputWrap}>
                  <input 
                    type='text'
                    placeholder="Please enter the SecretKey value exactly(copy and paste)"
                    value={secretkey}
                    onChange={handleSecretkey}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                </div>
                {!secretkeyValid && secretkey.length > 0 && (
                  <div style={styles.error}>Please enter correct Secretkey inputs.</div>
                )}
              </div>

              <div style={styles.field}>
                <div style={styles.labelRow}>
                  <span style={styles.label}>Nickname</span>
                </div>
                <div style={styles.inputWrap}>
                  <input 
                    type='text'
                    placeholder="Enter at least 2 characters and no more than 8 characters."
                    value={nickname}
                    onChange={handleNickname}
                    onKeyDown={handleKeyDown}
                    style={styles.input}
                    className="signup-input"
                  />
                </div>
                {!nicknameValid && nickname.length > 0 && (
                  <div style={styles.error}>Please enter a valid nickname.</div>
                )}
              </div>

              <div style={styles.checkboxRow}>
                <label style={styles.checkboxLabel}>
                  <input 
                    type="checkbox"
                    checked={homeconsent}
                    onChange={handleHomeconsent}
                  />
                  {' '}Speed BOT 사이트 이용약관에 동의합니다{' '}
                  <a href="/HomeTerms" target="_blank" rel="noopener noreferrer" style={styles.link}>(내용확인)</a>
                </label>

                <label style={styles.checkboxLabel}>
                  <input 
                    type="checkbox"
                    checked={consent}
                    onChange={handleConsent}
                  />
                  {' '}개인정보 수집/이용에 동의합니다{' '}
                  <a href="/PrivacyTerms" target="_blank" rel="noopener noreferrer" style={styles.link}>(내용확인)</a>
                </label>
              </div>

              <div style={styles.submitRow}>
                <button 
                  onClick={() => onClickSaveFile()} 
                  disabled={notAllow} 
                  style={{ 
                    ...styles.submitBtn, 
                    ...(notAllow ? styles.submitBtnDisabled : {}) 
                  }}>
                  Sign up
                </button>
              </div>

              <div style={styles.linksRow}>
                <Link to="/" style={styles.link}>메인 페이지</Link>
                <Link to="/LoginAts" style={styles.link}>로그인 페이지</Link>
              </div>
            </div>
          </div>
        </div>

        {showMessage && (
          <div style={styles.popup}>
            {confirmMessage}
          </div>
        )}
        </div>
      </>
    );
}